import {GET_ALL_BANK_REGISTER,SET_SEARCH_BANK_REGISTER,SELECT_FILTER_OPTION_BANK_REGISTER,FILTER_BANK_REGISTER,SET_ADD_BANK_REGISTER_MODAL_OPEN,
        SET_ADD_BANK_REGISTER_MODAL_CLOSE,TOOGLE_DRAWER_BANK_REGISTER} from '../../../../constants/ActionTypes'
const InitialState={
    AllData:[],
    Data:[],
    selectedSectionId: 2,
    drawerState: false,
    search: '',
    filterOption: 'All contacts',
    addModalVisible: false,
}

function BankRegisterMaintenace(state=InitialState,action){
    switch (action.type) {

        case GET_ALL_BANK_REGISTER:
        return {
                ...state,
                AllData:action.payload,
                Data:action.payload.filter(x=>((state.selectedSectionId===1)?true:false) || (state.selectedSectionId===2 && x.active===true ) || (state.selectedSectionId===3 && x.active===false )),
            };
        case SET_SEARCH_BANK_REGISTER:
            return {
                ...state,
                search:action.payload
            };
        case SELECT_FILTER_OPTION_BANK_REGISTER:
            switch (action.payload) {
                case 1: 
                return{
                    ...state,
                    Data:state.AllData,
                    selectedSectionId:action.payload
                }
                case 2:
                    return {
                        ...state,
                        Data:state.AllData.filter(row=>row.active===true)
                        ,selectedSectionId:action.payload
                    }
                case 3: 
                    return {
                        ...state,
                        Data:state.AllData.filter(row=>row.active===false), 
                        selectedSectionId:action.payload
                    }
                default:
                    return state
            }
            case FILTER_BANK_REGISTER:
               
            const NData=state.AllData.filter((row)=>`${row.code} ${row.description}${((row.active)?'Activo':'Inactivo')}`.toLowerCase().indexOf(state.search.toLowerCase())!==-1)
                .filter((x)=>((state.selectedSectionId===1)?true:false) || (state.selectedSectionId===2 && x.active===true ) || (state.selectedSectionId===3 && x.active===false ))
               
                return {
                ...state,
                Data:NData
                };

            case SET_ADD_BANK_REGISTER_MODAL_OPEN:
                return {
                    ...state,
                    addModalVisible:action.payload
                } 
            case SET_ADD_BANK_REGISTER_MODAL_CLOSE:
                return {
                    ...state,
                    addModalVisible:action.payload
                }
            case TOOGLE_DRAWER_BANK_REGISTER:
                return {
                    ...state,
                    drawerState:!state.drawerState
                }
        default:
            return state
    }
}

export default BankRegisterMaintenace;